import { useState } from 'react'
import { Dialog } from '../../../components/ui/dialog'
import CommissionCard from './CommissionCard'
import NewSimulationCard from './NewSimulationCard'
import ChooseSimulationModal from './ChooseSimulationModal'
import FgtsModal from './Simulations/Fgts'
import CrefazModal from './Simulations/Crefaz'
import { PartnerType } from '@/app/utils/partners.enum'
import SalvcarModal from './Simulations/Salvcar'
import PanModal from './Simulations/Pan'

type StepType = PartnerType | 'chooseSimulation' | null

export default function SellerCards({ value = 0 }: { value?: number }) {
  const [open, setOpen] = useState(false)
  const [step, setStep] = useState<StepType>(null)

  const handleOpen = () => {
    setOpen(true)
    setStep('chooseSimulation')
  }

  const handleOptionSelect = (option: PartnerType) => setStep(option)

  const handleBackToChoose = () => setStep('chooseSimulation')

  return (
    <>
      <CommissionCard value={value} />

      <Dialog open={open} onOpenChange={setOpen}>
        <NewSimulationCard onClick={handleOpen} />

        {step === 'chooseSimulation' && (
          <ChooseSimulationModal onOptionSelect={handleOptionSelect} />
        )}

        {step === PartnerType.FGTS && <FgtsModal onBack={handleBackToChoose} />}

        {step === PartnerType.CREFAZ && (
          <CrefazModal onBack={handleBackToChoose} onClose={() => setOpen(false)} />
        )}

        {step === PartnerType.SALVCAR && (
          <SalvcarModal onBack={handleBackToChoose} />
        )}

        {step === PartnerType.PAN && <PanModal onBack={handleBackToChoose} />}
      </Dialog>
    </>
  )
}
